import { JobPosition } from '@restworld/utility-types';

export interface RecruiterInsightItem {
  key: 'recruiter-profile';
  icon: string;
  rating: 1;
  title: string;
  subTitle: string;
}

// The public projection of the job position endpoint does not carry
// `csm_insights` for an unauthenticated caller, so on the public listing page
// this card has no content to show and must not be rendered at all. The name is
// interpolated into the title and the insight is the whole body, so a value
// that is only whitespace produces a card with a dangling comma or an empty
// paragraph, which is the broken state this guard exists to prevent.
export const buildRecruiterInsightItem = (
  jobPosition: Partial<JobPosition> | null | undefined,
  t: (key: string, options?: Record<string, unknown>) => string
): RecruiterInsightItem | null => {
  const insight = jobPosition?.csm_insights?.trim();
  const recruiterName = jobPosition?.assigned_to_user?.name?.trim();

  if (!insight || !recruiterName) return null;

  return {
    key: 'recruiter-profile',
    icon: jobPosition?.assigned_to_user?.icon_url || '',
    rating: 1,
    title: t('job_position_recruiter_insight_title', { name: recruiterName }),
    subTitle: insight,
  };
};
